import { render } from "./SubscribeContent.vue?vue&type=template&id=456f9a36&ts=true"
import script from "./SubscribeContent.vue?vue&type=script&lang=ts"
export * from "./SubscribeContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__